import { AreaVisitsIcon } from 'src/components/insights/icons/area-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/area-visits-foot-traffic-trends.png'

const AreaVisitsTrendsCard = dynamic(() => import('src/components/insights/area-visits/visit-trends'), {
  ssr: false,
})

export const AreaVisitsTrendsWidget: InsightBuilderWidget = {
  id: 'area-visits-trends',
  name: 'Area Visits: Foot-Traffic Trends',
  type: 'Area Visits',
  icon: AreaVisitsIcon,
  component: AreaVisitsTrendsCard,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
